var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalutiored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 150,
    cy: 46.2,
    r: 27.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209,278.7l-59-59l-59,59c-7.2,7.2-19.3,0-16.3-9.7c3.2-10.7,6.2-22.6,8.8-35.5l31.5-48.8l7.2-11.1 c4.8-7.4,2.7-17.3-4.7-22.1l-6.6-4.3l-22-14.2c-2.4-28.5-7.9-53.5-14.1-74.2c-2.9-9.8,9.1-17,16.3-9.8l59,59l59-59 c7.2-7.2,19.2,0,16.3,9.8c-6.2,20.7-11.7,45.7-14.1,74.2v0l-22,14.2l-6.6,4.3c-7.4,4.8-9.5,14.7-4.7,22.1l7.2,11.1l31.6,48.8 c2.5,12.9,5.5,24.8,8.7,35.5C228.2,278.7,216.2,285.9,209,278.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 56.6,
    cy: 86.5,
    r: 17.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 243.4,
    cy: 86.5,
    r: 17.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115,169l-6.2,9.5l-21.9,33.8l-34.3,53c-4.2,6.4-14.2,3-13.5-4.6c1.8-22,1.4-49.7-5.4-80.7 C27.1,150,16.4,125.2,6,106.2c-3.7-6.7,4-13.9,10.5-9.7l73.2,47.3l15,9.7l8.2,5.3C116.2,161,117.2,165.6,115,169z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294,106.2c-10.4,19-21.2,43.8-27.7,73.9c-6.7,30.9-7.2,58.6-5.4,80.7c0.6,7.6-9.4,11-13.5,4.6l-34.3-53 l-21.9-33.8L185,169c-2.2-3.4-1.2-8,2.2-10.2l8.2-5.3l15-9.7l73.2-47.3C290,92.3,297.7,99.5,294,106.2z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalutiored);
export default __webpack_public_path__ + "static/media/salutiored.1b6cfa32da66d59cc0e5c09aa52c5e90.svg";
export { ForwardRef as ReactComponent };